<template>
    <div class="mt-1 director-interest-details">
        <!-- Table Container Card -->
        <b-card no-body class="mb-0" data-test="director-interest-view">
            <b-card-header tag="h1" class="border-bottom">
                   <div class="header-title">
                        <h1 class="mb-0">{{ dataDirectorInterestDetails.title }}</h1>
                   </div>

            </b-card-header>
            
            <div v-for="(type, i) in types" :key="type">
                <b-card-body v-if="localizeDirectorInterestDetailsData[i].length">
                    <header class="h4 title text-primary font">
                        {{ type }}
                    </header>
                    <b-table
                        ref="refDirectorInterestViewDetailsTable"
                        class="mt-1"
                        :items="localizeDirectorInterestDetailsData[i]"
                        :fields="tableColumns"
                        responsive
                        primary-key="_id"
                    >

                        <template  #cell(index)="data" >
                            {{ data.index + 1 }}
                        </template>

                        <template #cell(actions) = "data">
                            <div v-if="! data.item.isGenerated" class="cursor-pointer d-flex align-items-center justify-content-center">
                                <div v-if="isUserAdmin">
                                    <b-dropdown size="sm" menu-class="" dropright variant="link" toggle-class="text-decoration-none" no-caret>
                                        <template #button-content>
                                            <feather-icon icon="MoreVerticalIcon"/>
                                        </template>

                                        <b-dropdown-item
                                            :data-test="`edit-${data.item.date}`"
                                            @click="edit(data)"
                                        >
                                            <div class="d-flex align-items-center">
                                                <feather-icon icon="EditIcon" />
                                                <span style="padding-top: .1em; padding-left: .5em">Edit</span>
                                            </div>
                                        </b-dropdown-item>
                                        
                                        <b-dropdown-item
                                            :data-test="`delete-${data.item.date}`"
                                            @click="remove(data)"
                                        >
                                            <div class="d-flex align-items-center">
                                                <feather-icon icon="TrashIcon" />
                                                <span style="padding-top: .1em; padding-left: .5em">Delete</span>
                                            </div>
                                        </b-dropdown-item> 
                                    </b-dropdown>
                                </div>
                            </div>
                            <div v-else>
                                <div class="d-flex align-items-center justify-content-center">
                                    🛇
                                </div>
                            </div>
                        </template>
                    </b-table>

                    <loader v-if="isLoading" data-type="Table" />
                </b-card-body>
            </div>
        </b-card>
    </div>
</template>

<script>
import {
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BDropdown,
    BDropdownItem,
} from "bootstrap-vue";
import { ref } from '@vue/composition-api';
import { mapGetters } from 'vuex';

export default {
    components: {
        BCard,
        BTable,
        BCardBody,
        BCardHeader,
        BDropdown,
        BDropdownItem,
    },

    props: {
        // eslint-disable-next-line vue/require-default-prop
        dataDirectorInterestDetails: {
            required: true,
            type: Object
        },

        payloadForDetailsView: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapGetters({
            companyName: 'company/fullCompanyName',
            isUserAdmin: "auth/isAdmin",
        }),
    },

    created() {
        // if user is not admin then don't show action column
        // if(!this.isUserAdmin) {
        //     this.tableColumns.pop();
        // }
    },

    methods: {
        edit(data) {
            this.$emit('edit', data, "edit");
        },

        remove(data) {
            this.$emit('remove', data);
        }
    },

    setup(props) {
        const localizeDirectorInterestDetailsData = ref([]);
        const types = ref([]);

        const {
            isLoading,
            tableColumns,
            directorInterestViewList,
            fetchDirectorInterests,
            refDirectorInterestViewDetailsTable,
            localizeDirectorInterestDetails,
        } = props.payloadForDetailsView;

        Object.keys(props.dataDirectorInterestDetails.body).forEach(key => {
            types.value.push(key);
            localizeDirectorInterestDetailsData.value.push(props.dataDirectorInterestDetails.body[key].map(di => localizeDirectorInterestDetails(di)));
        });
        
        return {
            tableColumns,
            fetchDirectorInterests,
            refDirectorInterestViewDetailsTable,
            localizeDirectorInterestDetails,
            localizeDirectorInterestDetailsData,
            types,

            directorInterestViewList,

            // UI
            isLoading,
        };
    }
};
</script>

<style lang="scss" scoped>

 .director-interest-details .table-responsive {
    overflow-x: auto!important;
}

.director-main-info img {
    width: 8%;
    margin: auto;
    position: relative;
    top: 14px;
}

.director-main-info .card {
  border: none !important;
}

.director-main-info .card-body {
  border: 1px solid #ebe9f1 !important;
  box-shadow: 0px 0px 22px 2px #e3e3e3;
  border-radius: 10px;
//   padding: 20px 10px;
}

.header-title {
  width: 100%;
  display: flex;
  justify-content: inherit;
}
</style>